import { SearchProject, SearchResults, SearchTicket, User } from "@/shared/lib/types/user";
import { GetMyDetailsResponse, GetMyPermissionsResponse, SearchMineResponse } from "@/shared/lib/types/user/responses";
import http from "@/shared/lib/utils/http";

export async function getMyDetails(): Promise<User> {
  const response = await http.get<GetMyDetailsResponse>({
    url: "/users/me",
    contentType: "none",
  });

  return {
    id: response.id,
    firstName: response.first_name,
    lastName: response.last_name,
    emailAddress: response.email_address,
  };
}

export async function searchMine(query: string): Promise<SearchResults> {
  const params = new URLSearchParams();
  params.set("query", query);

  const response = await http.get<SearchMineResponse>({
    url: `/users/me/search?${params.toString()}`,
    contentType: "none",
  });

  return {
    projects: response.projects.map(
      (dto): SearchProject => ({
        id: dto.id,
        name: dto.name,
      })
    ),
    tickets: response.tickets.map(
      (dto): SearchTicket => ({
        id: dto.id,
        key: dto.key,
        title: dto.title,
        projectId: dto.project_id,
      })
    ),
  };
}

export async function getMyPermissions(): Promise<string[]> {
  const response = await http.get<GetMyPermissionsResponse>({
    url: "/users/me/permissions",
    contentType: "none",
  });

  return response.permissions;
}
